import { render, staticRenderFns } from "./MetadataReadOnlyPanel.vue?vue&type=template&id=a621e9c4"
import script from "./MetadataReadOnlyPanel.vue?vue&type=script&lang=js"
export * from "./MetadataReadOnlyPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports